function is_touch_device() {
 return (('ontouchstart' in window)
      || (navigator.MaxTouchPoints > 0)
      || (navigator.msMaxTouchPoints > 0));
}
if(is_touch_device())
    jQuery('body').addClass('touch-device');

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, "includes", {
    enumerable: false,
    value: function(obj) {
        var newArr = this.filter(function(el) {
          return el == obj;
        });
        return newArr.length > 0;
      }
  });
}

jQuery.extend({
  getQueryParameters : function(str) {
      var params=(str || document.location.search).replace(/(^.*?\?)/,'');
      if(params=="")
        return {};
      return params.split("&").map(function(n){return n = n.split("="),this[n[0]] = decodeURIComponent(n[1]),this}.bind({}))[0];
  },
  getPathname : function(str) {
      var el = document.createElement('a');
      el.href = str;
      return el.pathname;
  }
});

jQuery(document).ready(function($){
    
    $('#aptForm').on('submit',function(e){
        var $form = $(this);

        if ($form.data('submitted') === true) {
            e.preventDefault();
        } else {
            $form.data('submitted', true);
        }
    });
    
	orig = $.fn.css;
    $.fn.css = function() {
        var ev = new $.Event('style');
        $(this).trigger(ev);
        if(ev.target==$('html')[0])
        {
        	if(typeof arguments[0].marginRight != 'undefined')     
        	{
        		if(arguments[0].marginRight=="")
        			$('.site-header .top-bar, .site-header .nav-bar').css('padding-right',0);
        		else
        			$('.site-header .top-bar, .site-header .nav-bar').css('padding-right',arguments[0].marginRight+'px');
        	}   		
        		
        }
        
        return orig.apply(this, arguments);
    }
    //$('.datepicker').pikaday({format:'MM/DD/YYYY'});
    if($('body.alt-nav').length>0)
    {
        var navbartop=100+($('#wpadminbar').length?32:0);
        var fix;
        $(window).scroll(function(e){            
            fix = navbartop - parseFloat($('.top-bar').css('top')) - $('.top-bar').height();
            if($(this).scrollTop()>fix)
                $('.nav-bar').addClass('fixed');
            else
                $('.nav-bar').removeClass('fixed');
        });
        $('.nav-bar').css('transition','none');
        $(window).scroll();
        setTimeout(function(){
            $('.nav-bar').css('transition','');
        },400);
        
    }
	$('.site-header button.event:not(.accrue-trigger)').click(function(e){
        e.preventDefault();
        $(this).siblings('.event-popup, .content-popup').slideToggle();
        var i=$('.plus',this);
        i.text(i.text() == '+' ? '-' : '+');
    });
	$('#nav-toggle').on('click', function(e) {
		e.preventDefault();
		if($('#nav-toggle').data('clicked'))
			return;
		$('#nav-toggle').data('clicked',true);		
      	$('#nav-toggle').toggleClass('active');
      	if($.magnificPopup.instance.isOpen)
        {
            $('#nav-toggle').removeClass('active');
			$.magnificPopup.close();            
        }
		else
        {
            $('#nav-toggle').addClass('active');
			openMobileMenu();
        }
		setTimeout(function(){
			$('#nav-toggle').data('clicked',false);
		},310);
    });
    function openMobileMenu()
    {
    	var holder=$('<div class="mobile-menu"></div>');
    	var nav=$('.nav-bar nav').clone(true,true);
        var topLinks = $('.top-bar .links a').clone(true,true).wrap('<li></li>').parent();
        var appt_button=$('.nav-bar .primary-button').clone(true,true).wrap('<li></li>').parent();
        $('> ul', nav).append(topLinks);
        $('> ul', nav).append(appt_button);
    	//var navBefore=$('<div>');
    	//nav.before(navBefore);
    	var topFunctions=$('.top-bar .top-functions').clone(true,true);      
    	//var topFunctionsBefore=$('<div>');    
    	//topFunctions.before(topFunctionsBefore);
    	holder.append(topFunctions);
        holder.append($('.favorites-popup',topFunctions));
        holder.append($('.wishlist-popup',topFunctions));
    	holder.append(nav);
    	$.magnificPopup.open({
			items: {
				src:holder
			},
			callbacks:
			{
				afterClose:function(){
					$('html').css('overflow','visible');
                    $('#nav-toggle').css('z-index',10);
                    $('#nav-toggle').removeClass('active');
				},
                beforeOpen:function(){
                    $('html').css('overflow','hidden');
                    $('#nav-toggle').css('z-index',100000);
                }
			},
            autoFocusLast:false,
			closeOnBgClick:false,
			showCloseBtn:false,
			enableEscapeKey: false,
			alignTop: true,
			removalDelay: 300,
			mainClass: 'mfp-fade mobile-menu-holder'
		});
    }
    $('#filters-toggle').on('click', function(e) {
        e.preventDefault();
        if($('#filters-toggle').data('clicked'))
            return;
        $('#filters-toggle').data('clicked',true);      
        $('#filters-toggle').toggleClass('active');        
        openProductFilters();
        setTimeout(function(){
            $('#filters-toggle').data('clicked',false);
        },310);
    });
    function openProductFilters()
    {
        var holder=$('<div class="mobile-filters"></div>');
        var topFunctions=$('<div class="top-functions"><div class="back">Back <i class="fa fa-angle-right" aria-hidden="true"></i></div><h3>Search Criteria</h3></div>');
        var filters=$('.filters-area > .top > .filter');
        var updateFilters=$('<div class="update-filters">Search</div>');
        updateFilters.click(updateFiltersButton);
        var filtersBefore=$('<div>');
        filters.before(filtersBefore);
        $('.back',topFunctions).click(function(){
            $.magnificPopup.close();
        });
        holder.append(topFunctions);
        holder.append(filters);   
        holder.append(updateFilters);                     
        $.magnificPopup.open({
            items: {
                src:holder
            },
            callbacks:
            {
                beforeClose:function(){
                    filters=filters.clone(true,true);   
                },
                afterClose:function(){
                    $('html').css('overflow','visible');
                    filtersBefore.after(filters);
                    filtersBefore.remove();
                },
                beforeOpen:function(){
                    $('html').css('overflow','hidden');
                }
            },
            autoFocusLast:false,
            closeOnBgClick:false,
            showCloseBtn:false,
            enableEscapeKey: false,
            alignTop: true,
            removalDelay: 300,
            mainClass: 'mfp-fade mobile-filter-holder'
        });
        filters.show();
    }
    $(window).resize(function(){
        if(!$('#filters-toggle').is(':visible')&&$('.mobile-filter-holder').length!=0&&$.magnificPopup.instance.isOpen)
        {
            $.magnificPopup.close();
            $('#filters-toggle').removeClass('active');
        }
    	if(!$('#nav-toggle').is(':visible')&&$('.mobile-menu-holder').length!=0&&$.magnificPopup.instance.isOpen)
    	{
    		$.magnificPopup.close();
    		$('#nav-toggle').removeClass('active');
            closeSubMenu($('.mobile-menu'),true);            
    	}
    });
    $('.menu-item-has-children .arrow').click(function(){
        var mm=$(this).closest('.mobile-menu');
        var li=$(this).closest('li');
        var top=$('<div class="sub-top"></div>');
        var back=$('<div class="back"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</div>');
        top.append(back).append('<h3>'+li.find('>a').text()+'</h3>');
        back.click(function(){
            closeSubMenu(mm,false);            
        });
        $('.top-functions',mm).append(top);
        TweenMax.to('#nav-toggle',.6,{left:'-100%',ease:Power1.easeInOut});
        TweenMax.to($('.top-functions',mm),.6,{left:'-100%',ease:Power1.easeInOut});
        li.find('.mega').show();
        TweenMax.to($('nav',mm),.6,{left:'-100%',ease:Power1.easeInOut});        

    });
    function closeSubMenu(mm,instant)
    {
        var speed=.6;
        if(instant)
            speed=0;
        TweenMax.to('#nav-toggle',speed,{left:'0',ease:Power1.easeInOut});
        TweenMax.to($('.top-functions',mm),speed,{left:'0',ease:Power1.easeInOut});
        TweenMax.to($('nav',mm),speed,{left:'0%',ease:Power1.easeInOut,onComplete:function(){
            $('.sub-top',mm).remove();
            $('.mega',mm).hide();
        }});
    }
/*
    $('.product-images .main-slider .image, .product-images .product-thumbnails .thumb').click(function(e){
        var items=[];
        var imageHolder=$(this);
        if(!imageHolder.hasClass('slick-current'))
            return;
        var img;
        var index=0;
        //items.push({src:imageHolder.data('url'),captitle:img.attr('title'),caption:img.attr('alt')});
        imageHolder.parent().children().each(function(i){
            if(this==imageHolder[0])
                index=i;
            img=$('img',this);
            items.push({src:$(this).data('url'),captitle:img.attr('title'),caption:img.attr('alt')});
        });
        $.magnificPopup.open({
            items: items,
            gallery: {
              enabled: true
            },            
            type: 'image',   
            autoFocusLast:false,         
            image: {
                titleSrc: function(item){
                    return item.data.captitle+'<small>'+item.data.caption+'</small>';
                }
            },            
            removalDelay: 300,
            mainClass: 'mfp-fade'
            
        },index);
    });
*/

    //$('.product-images').show();
   
    $('.product-images .main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        //arrows: false,
        fade: true,
        prevArrow:'<div class="prev"><i class="fa fa-angle-left"></i></div>',
        nextArrow:'<div class="next"><i class="fa fa-angle-right"></i></div>',
        asNavFor: '.product-images .product-thumbnails'
    }).removeClass('hide-pre-js');

    $('.product-images .product-thumbnails').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.product-images .main-slider',
        vertical: true,
        //centerMode: true,
        focusOnSelect: true
    }).removeClass('hide-pre-js');

    $('.product-images .main-slider .video').click(function(){
        var heading='';
        $.magnificPopup.open({
            items: {
                src:$(this).data('video')
            },
            type: 'iframe',
            removalDelay: 300,
            mainClass: 'mfp-fade',
            iframe: {
                markup: '<div class="video-popup">'+heading+'<div class="mfp-close"></div><div class="mfp-iframe-scaler">'+
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                '</div></div>',
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: 'v=',
                        src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
                    }
                }
            }
        });
    });
    
    if(!is_touch_device()||$(window).width()>1000)
    {
        $('.product-images .main-slider .image').each(function(){
            var self=$(this);
            $(this).zoom({
                url:$(this).data('url'),
                callback:function(){
                    if(this.width<self.width())
                        self.trigger('zoom.destroy');
                    this.setAttribute('aria-hidden', 'true');
                    this.setAttribute('alt', $('img',self).attr('alt')+' zoomed in');
                }
            });
        });
    }
    

    $('.item-slider-4').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:'<div class="prev"><i class="fa fa-angle-left"></i></div>',
        nextArrow:'<div class="next"><i class="fa fa-angle-right"></i></div>',
        responsive: [
            {
              breakpoint: 940,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 730,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 506,
              settings: {
                slidesToShow: 1,
                centerMode:true,
                infinite:false,
              }
            },
            {
              breakpoint: 390,
              settings: {
                slidesToShow: 1,
                centerMode:false
              }
            }
        ]
    }).show();
   
    $('.item-slider-3').slick({
        slidesToShow: 3,
        slidesToScroll: 1,            
        prevArrow:'<div class="prev"><i class="fa fa-angle-left"></i></div>',
        nextArrow:'<div class="next"><i class="fa fa-angle-right"></i></div>',
        responsive: [
            {
              breakpoint: 940,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 540,
              settings: {
                slidesToShow: 1,
                centerMode:true,
                infinite:false
              }
            },
            {
              breakpoint: 440,
              settings: {
                slidesToShow: 1,
                centerMode:false
              }
            }
        ]
    }).addClass('show');

    $('.k-custom-slider').each(function(){
        var slidesToShow=$(this).data('show');
        var buttons=$(this).data('buttons');
        var autoplay=$(this).data('autoplay');
        var transition=$(this).data('transition');
        var responsive=false;
        switch(slidesToShow)
        {
            case 2:
                responsive=[
                    {
                      breakpoint: 760,
                      settings: {
                        slidesToShow: 1,
                        centerMode:true,
                        infinite:false
                      }
                    },
                    {
                      breakpoint: 500,
                      settings: {
                        slidesToShow: 1
                      }
                    }
                ];
                break;
            case 3:
                responsive=[
                    {
                      breakpoint: 940,
                      settings: {
                        slidesToShow: 2
                      }
                    },
                    {
                      breakpoint: 700,
                      settings: {
                        slidesToShow: 1
                      }
                    },
                    {
                      breakpoint: 540,
                      settings: {
                        slidesToShow: 1,
                        centerMode:true,
                        infinite:false
                      }
                    },
                    {
                      breakpoint: 440,
                      settings: {
                        slidesToShow: 1,
                        centerMode:false
                      }
                    }
                ];
                break;
            case 4:
                responsive=[
                    {
                      breakpoint: 940,
                      settings: {
                        slidesToShow: 3
                      }
                    },
                    {
                      breakpoint: 730,
                      settings: {
                        slidesToShow: 2
                      }
                    },
                    {
                      breakpoint: 506,
                      settings: {
                        slidesToShow: 1,
                        centerMode:true,
                        infinite:false,
                      }
                    },
                    {
                      breakpoint: 390,
                      settings: {
                        slidesToShow: 1,
                        centerMode:false
                      }
                    }
                ];
                break;
        }
        var args={
            slidesToShow: slidesToShow,
            slidesToScroll: 1,            
            prevArrow:'<div class="prev"><i class="fa fa-angle-left"></i></div>',
            nextArrow:'<div class="next"><i class="fa fa-angle-right"></i></div>',
            responsive:responsive
        };
        switch(buttons)
        {
            case 'arrows':
                args.arrows=true;
                args.dots=false;
            break;
            case 'circles':
                args.arrows=false;
                args.dots=true;
            break;
            case 'none':
                args.arrows=false;
                args.dots=false;
            break;
        }
        if(transition=="fade")
            args.fade=true;
        if(autoplay!=0)
        {
            args.autoplay=true;
            args.autoplaySpeed=autoplay*1000;
        }
        $(this).slick(args).show();
    })
    $('.simple-image-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      prevArrow:'<div class="prev"><i class="fa fa-angle-left"></i></div>',
      nextArrow:'<div class="next"><i class="fa fa-angle-right"></i></div>',
      variableWidth: true
    }).show();

    
    $('.appointment-callout-block .image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        prevArrow:'<div class="prev"><i class="fa fa-angle-left"></i></div>',
        nextArrow:'<div class="next"><i class="fa fa-angle-right"></i></div>',
    });

    $('.top-functions .phone span.fa').click(function(e){
        e.preventDefault();
        var span=$(this).siblings('span.number');
        if(span.css('position')=='fixed')
            span.animate({height: 'toggle'}).css("display","inline-block");
        else
            span.animate({width: 'toggle'}).css("display","inline-block");
    });
    $('.top-functions form > button, .nav-bar form > button').click(function(e){  
        var holder=$(this).siblings('.search-holder');
        if(!holder.hasClass('show') || $('input', holder).val()=="")
        {
            e.preventDefault();
            holder.addClass('show');
            var phone_span=$('.top-functions .phone span.number');
            if(phone_span.is(':visible'))
            {
                
                if(phone_span.css('position')=='fixed')
                    phone_span.animate({height: 'hide'}).css("display","inline-block");
                else
                    phone_span.animate({width: 'hide'}).css("display","inline-block");
            }
        }        
    });
    $('.top-functions div.account').click(function(e){
        if(e.target==this)
            $('.login-dropdown',this).slideToggle();
    });
    $('.top-functions .add-to-favorites span.fa, .top-functions .add-to-favorites .count').click(function(){
        $(this).closest('.top-functions').parent().find('.favorites-popup').slideToggle();
    });
    $('.top-functions .add-to-wishlist span.fa, .top-functions .add-to-wishlist .count').click(function(){
        $(this).closest('.top-functions').parent().find('.wishlist-popup').slideToggle();
    });
    /*
    $('.nav-bar .k-menu-holder').on('click mouseenter mouseleave',function(e){
        if($(this).siblings('nav').is(':visible'))
        {
            if(e.type=="mouseenter")
                $('.nav-bar .k-menu').stop().slideDown();
            else if(e.type=="mouseleave")
                $('.nav-bar .k-menu').stop().slideUp();
        }
        else if(e.type=="click")
        {
            $('.nav-bar .k-menu').slideToggle();
        }
    });
    */
    /*
    .hover(function(){
        $('.nav-bar .k-menu').stop().slideDown();
    },function(){
        $('.nav-bar .k-menu').stop().slideUp();
    });
    */
    $(document).click(function(e){
        var target=$(e.target);
        if(target.closest('.top-functions form, .nav-bar form').length==0)
            $('.top-functions .search-holder, .nav-bar .search-holder').removeClass('show');
        if(target.closest('.top-functions .add-to-favorites, .favorites-popup').length==0)       
            $('.top-functions').parent().find('.favorites-popup').slideUp();
        if(target.closest('.top-functions .add-to-wishlist, .wishlist-popup').length==0)       
            $('.top-functions').parent().find('.wishlist-popup').slideUp();
    });
   

    
    $('.widget_layered_nav a').each(function(){
        if($(this).closest('li').is('.chosen'))
            $(this).data('chosen',true);
        else
            $(this).data('chosen',false);
    });

    $('.widget_layered_nav a, .k-filter-nav a, .k-category-nav a').click(function(e){
        e.preventDefault();
        $(this).closest('li').toggleClass('chosen');
        $('.update-filters').show();
    });
    $( document.body ).on( 'price_slider_change',function(){
        $('.update-filters').show();
    });
    function getFilters()
    {
        var currFilters={};
        var baseFilters=$.getQueryParameters(); 
        var urlParams=$.getQueryParameters();

        $.each(baseFilters,function(i){
            if(i.substring(0,7)!='filter_')
                delete baseFilters[i];
        });
        function updateFilters(name,val)
        {
            if(typeof currFilters[name] == 'undefined')
            {
                currFilters[name]=val;
            }
            else
            {
                currFilters[name]+=','+val;
            }
        }
        $('.widget_layered_nav li.chosen a').each(function(){  
            var self=$(this);
            var newFilters=$.getQueryParameters(self.attr('href'));
            if(self.data('chosen'))
            {
                $.each(baseFilters,function(i,v){
                    if(typeof newFilters[i] == 'undefined')
                    {
                        updateFilters(i,v);
                        return;
                    }
                    if(newFilters[i]!=v)
                    {
                        updateFilters(i,v.replace(newFilters[i],'').replace(',',''));
                        return;
                    }
                });
            }
            else
            {
                $.each(newFilters,function(i,v){
                    if(typeof baseFilters[i] == 'undefined')
                    {
                        updateFilters(i,v);
                        return;
                    }
                    if(baseFilters[i]!=v)
                    {
                        updateFilters(i,v.replace(newFilters[i],'').replace(',',''));
                        return;
                    }
                });
            }
        });
        $.each(baseFilters,function(i){
            if(i.substring(0,7)!='filter_')
                delete baseFilters[i];
        });
        $('.k-filter-nav li.chosen > a').each(function(){
            var newFilters=$.getQueryParameters($(this).attr('href'));
            $.each(newFilters,function(i,v){
                updateFilters(i,v);
            });
        });
        $('.k-category-nav li.chosen > a').each(function(){
            var newFilters=$.getQueryParameters($(this).attr('data-href'));
            $.each(newFilters,function(i,v){
                updateFilters(i,v);
            });
        });
        if($('.k-category-nav li.chosen > a').length==0 && $('.k-category-nav').data('is-child'))
        {
            updateFilters('parent_cat',1);            
        }
        
        
        var min=jQuery('input#min_price').val();
        if(min>jQuery('input#min_price').data('min'))
            currFilters['min_price']=min;

        var max=jQuery('input#max_price').val();
        if(max<jQuery('input#max_price').data('max'))
            currFilters['max_price']=max;

        if(typeof urlParams['orderby'] != 'undefined' && urlParams['orderby']!='menu_order')        
            currFilters['orderby']=urlParams['orderby'];
        if(typeof urlParams['min_rating'] != 'undefined')        
            currFilters['min_rating']=urlParams['min_rating'];
        if(typeof urlParams['pp'] != 'undefined')        
            currFilters['pp']=urlParams['pp'];
        
        return currFilters;
    }
    if($('.filters-area .filter').length>0)
    {
        $(document).click(function(e){
            var filters=$('.filters-area .filter, .mobile-filters .filter').not($(e.target).closest('.filter'));
            filters.removeClass('active').attr("aria-expanded","false");
            $('.filters',filters).slideUp();
        });
    }
    $('.filters-area .top .filter > span').click(function(e){
        var filter=$(this).closest('.filter');
        filter.toggleClass('active').attr("aria-expanded","true");
        $('.filters',filter).slideToggle();
    });
    
    $('.update-filters').click(updateFiltersButton);
    function updateFiltersButton()
    {
        var filters=getFilters();        
        var href=$.param(filters);
        var base=window.location.pathname;
        base=base.replace(/\/page\/\d+/i,'');
        if(href=="")
            window.location.href=window.location.pathname;
        else
            window.location.href=base+'?'+href;
    }
    $('.widget_layered_nav_filters li a').click(function(e){
        e.preventDefault();
        var baseFilters=$.getQueryParameters(); 
        var newFilters=$.getQueryParameters($(this).attr('href'));

        $.each(baseFilters,function(i,v){
            if(i=="product_designer"||i=="product_cat"||i=="pp")
                return;
            if(typeof newFilters[i] == 'undefined')
            {
                delete baseFilters[i];
                return;
            }
            if(newFilters[i]!=v)
            {
                baseFilters[i]=newFilters[i];
                return;
            }
        });
        var href=$.param(baseFilters);

        if(href=="")
            window.location.href=window.location.pathname;
        else
            window.location.href='?'+href;
    });
    $('.k-nav-selected li a').click(function(e){
        e.preventDefault();
        var baseFilters = $.getQueryParameters(); 
        var newFilters = $.getQueryParameters($(this).attr('href'));
        var pathname = $.getPathname($(this).attr('href'));
        if(pathname!=document.location.pathname)
        {
            if(document.location.search=="")
                window.location.href=pathname;
            else
                window.location.href=pathname+'?'+document.location.search;
            return;
        }
        
        $.each(newFilters,function(i,v){
            if(typeof baseFilters[i] != 'undefined')
            {
                var arr=baseFilters[i].split(',');
                $(arr).each(function(j,w){
                    if(w==v)
                        arr.splice(j,1);
                });
                if(arr.length>0)
                    baseFilters[i]=arr.join();
                else
                    delete baseFilters[i];
            }
            
        });
        var href=$.param(baseFilters);

        if(href=="")
            window.location.href=window.location.pathname;
        else
            window.location.href='?'+href;        
    });
    $('.per-page a').click(function(e){
        e.preventDefault();
        var baseFilters=$.getQueryParameters(); 
        var newFilters=$.getQueryParameters($(this).attr('href'));
        $.each(newFilters,function(i,v){
            baseFilters[i]=v;

        });
        
        var href=$.param(baseFilters);

        window.location.href='?'+href;        
    });

    $('.accordion .heading').click(function(){ 
        var section=$(this).closest('.section')
        section.toggleClass('active').find('>.body').slideToggle();       
        $(this).closest('.accordion').find('.section').not(section).removeClass('active').find('> .body').slideUp();
    });
    $('.change-password-button').click(function(){
        $(this).closest('form').find('.change-password').slideToggle();
    });
    $('.account-top .section .section-title').click(function(e){
        var section=$(this).closest('.section');
        section.toggleClass('active');
        $('.section-content',section).slideToggle();
    });
    $(document).click(function(e){
        var section=$('.account-top .section').not($(e.target).closest('.account-top .section'));
        section.removeClass('active');
        $('.section-content',section).slideUp();
    });
    $('button.heart, button.wish, button.favorite-item, button.wishlist-item').click(function(e)
    {        
        if(!$(this).data('id'))
            return;
        e.preventDefault();
        var favorite = $(this).data('id');

        var heart=$(this);
        if(heart.data('disabled'))
            return;
        
        heart.data('disabled',true);
        heart.addClass('loading');
        $.get('/',{favorite:favorite,return:true},function(resp){
            if(typeof resp.action == 'undefined')
                return;
            heart.data('disabled',false);
            heart.removeClass('loading');
            var holder=heart.closest('.item, li, .product, .type-designer');
            var post_class=holder.attr('class').match(/\b(post-\d+)\b/);
            if(typeof post_class[1] != "undefined")
                holder=$('.'+post_class[1]);
            if(resp.action=="set")
                holder.addClass('favorite');
            else
                holder.removeClass('favorite');

            $('.top-functions .favorites').html(resp.popup);
            $('.top-functions .favorites-popup .email-favorites-button').click(email_favorites_button);
            $('.email-favorites-popup form').slideDown();
            $('.email-favorites-popup .sent-ok').slideUp();
            $('.email-favorites-popup .error').html('');
            update_favorite_count();            
        });
    });
    function email_favorites_button(e){
        e.preventDefault();
        if($.magnificPopup.instance.isOpen)
        {
            $.magnificPopup.close();
            setTimeout(function(){$('.email-favorites-button').click();},310);
            return;
        }
        $.magnificPopup.open({
            items: {
                src:$('.email-favorites-popup')
            },
            autoFocusLast:false,
            removalDelay: 300,
            mainClass: 'mfp-fade email-favorites-holder'
        });
    }
    function update_favorite_count()
    {
        var count=$('.top-functions .favorites-popup .fav-row').length;
        if(count==0)
        {
            $('.top-functions .add-to-favorites .count').hide();
        }
        else
        {
            $('.top-functions .add-to-favorites .count').show();
            $('.top-functions .add-to-favorites .count span').html(count);
        }


        count=$('.top-functions .wishlist-popup .fav-row').length;
        if(count==0)
        {
            $('.top-functions .add-to-wishlist .count').hide();
        }
        else
        {
            $('.top-functions .add-to-wishlist .count').show();
            $('.top-functions .add-to-wishlist .count span').html(count);
        }
    }
    update_favorite_count();
    $('.email-favorites-button').click(email_favorites_button);
    $('.email-favorites-popup input[name="who"]').change(function(){
        var popup=$(this).closest('.email-favorites-popup');
        var show=$(this).val();

        $('input[name="who"]',popup).each(function(){
            if($(this).val()!=show)
                $('.form-row.who_'+$(this).val(),popup).slideUp();
        });
        $('.form-row.who_'+show,popup).slideDown();
    });
    $('.email-favorites-popup form').submit(function(e){
        e.preventDefault();
        var form=$(this);
        if(form.data('submit'))
            return;
        form.data('submit',true);
        var data=form.serialize()+'&ajax_return=true&send-favorites-email=true';
        $.post('/',data,function(resp){
            form.data('submit',false);
            if(typeof resp.ok == 'undefined')
            {
                $('.error',form).html('Unknown error');
                return;
            }
            if(!resp.ok && typeof resp.error.show_captcha != 'undefined')
            {
                $('.form-row:last',form).before('<div class="form-row"><div id="g-recaptcha-email-fav"></div></div>');
                $('.error',form).html('Please complete the captcha above.');
                grecaptcha.render('g-recaptcha-email-fav', {
                  'sitekey' : '6LeOhS8UAAAAAKTaSi5mXVjphKzxZPIdPKHWU5AN'
                });
                return;
            }
            if(!resp.ok)
            {
                $('.error',form).html(resp.error);
                return;
            }
            form.closest('.email-favorites-popup').find('.sent-ok').slideDown();
            form.slideUp();
        });
    });
    $('.form-row-options .option img').click(function(){
        $(this).closest('.option').find('input[type="radio"]').click();
    });
    $('.form-row-options .option input[type=radio]').click(function(){
        var option=$(this).closest('.option');
        $(this).closest('.form-row-options').find('.option').not(option).find('.more').slideUp();
        $('.more',option).slideDown();
    });
    var clndrTemplate =
        "<div class='clndr-wrapper'>" +
            "<div class='clndr-controls'>" +
                "<div class='clndr-control-button'>" +
                    "<button type='button' class='clndr-previous-button'><span class='screen-reader-text'>Previous Month</span><span class='fa fa-angle-left' aria-hidden='true'></span></button>" +
                "</div>" +
                "<div class='month'><%= month %> <%= year %></div>" +
                "<div class='clndr-control-button rightalign'>" +
                    "<button type='button' class='clndr-next-button'><span class='screen-reader-text'>Next Month</span><span class='fa fa-angle-right' aria-hidden='true'></span></button>" +
                "</div>" +
            "</div>" +
            "<table class='clndr-table' border='0' cellspacing='0' cellpadding='0'>" +
                "<thead>" +
                    "<tr class='header-days'>" +
                    "<% for(var i = 0; i < daysOfTheWeek.length; i++) { %>" +
                        "<th scope='col' class='header-day'><abbr title='<%= extras.weekdays[i] %>'><%= extras.weekdaysshort[i] %></abbr></th>" +
                    "<% } %>" +
                    "</tr>" +
                "</thead>" +
                "<tbody>" +
                "<% for(var i = 0; i < numberOfRows; i++){ %>" +
                    "<tr>" +
                    "<% for(var j = 0; j < 7; j++){ %>" +
                    "<% var d = j + i * 7; %>" +
                        "<td class='<%= days[d].classes %>'>" +
                            "<<%=days[d].events.length>0?'a href=\"javascript:void(0);\"':'span' %> class='day-contents'><span class='screen-reader-text'><%= month %> </span><%= days[d].day %></<%=days[d].events.length>0?'a':'span' %>>" +
                        "</td>" +
                    "<% } %>" +
                    "</tr>" +
                "<% } %>" +
                "</tbody>" +
            "</table>" +
        "</div>" +
        "<div class='loading'></div>" +
        "<div class='legend'>" +
            "<div class='available'>Available Dates</div>" +
            "<div class='unavailable'>Unavailable Dates</div>" +
        "</div>";

    $('.appointment-calendar').each(function(){
        var recaptcha_id=false;
        var qparams=$.getQueryParameters();
        var refparams={};
        if(document.referrer.split("?").length==2)
            refparams=$.getQueryParameters(document.referrer.split("?")[1]);
        var appointment_calendar=$(this);
        var extra = appointment_calendar.html();
        appointment_calendar.html("");
        appointment_calendar.css('opacity', 1);
        if(typeof wp_vars['apt_datetime'] != 'undefined')
            qparams['apt']=wp_vars['apt_datetime'];
        if(typeof refparams['apt_date'] != 'undefined')
            qparams['apt']=refparams['apt_date'];
        if(typeof qparams['apt_date'] != 'undefined')
            qparams['apt']=qparams['apt_date'];

        var test_mode=appointment_calendar.data('test-mode');
        var hide_form=appointment_calendar.data('hide-form');
        var show_events=appointment_calendar.data('show-events');
        show_events=false;//v2 doesn't show events
    
        var booking_fee=appointment_calendar.data('booking-fee');
        if(booking_fee)
            booking_fee = atob(booking_fee);
        if(booking_fee)
            booking_fee = JSON.parse(booking_fee);

        var calendar_start=appointment_calendar.data('calendar-start');
        if(calendar_start)
            calendar_start = moment(calendar_start+'');
        else
            calendar_start = moment();
        if(calendar_start.isBefore(moment()))
            calendar_start = moment();

        var booking_fee_name = appointment_calendar.data('booking-fee-name');
        if(!booking_fee_name)
            booking_fee_name = 'Appointment fee';

        var apt_page_url=false;
            if(typeof wp_vars["apt_page_url"] != 'undefined')
                apt_page_url=wp_vars["apt_page_url"];

        var cal_holder=appointment_calendar;
        if(show_events)
        {
            var all_dates={};
            var events_display=$('<div class="events-display"><h3>Designer Events</h3><div class="grid-width"><div class="events">Pick a date on the calendar</div></div></div>');
            //cal_holder=$('<div class="calendar-and-events"></div>');
        }

        var cal=cal_holder.clndr({
            template:clndrTemplate,
            extras:{
                weekdays:['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                weekdaysshort:['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            },
            clickEvents: {
                click: function (target) {
                    if(target.events.length==0)
                        return;
                    
                    appointment_calendar.find('.form-holder .errors').html("");
                    $('.clndr .day',appointment_calendar).removeClass('active');
                    $(target.element).addClass('active');
                    //BEGIN events
                    if(show_events)
                    {
                        var date_str=target.date.format('YYYY-MM-DD');
                        if(typeof all_dates[date_str] == 'undefined')
                            all_dates[date_str]={date:target.date.toDate()};//make object that dailyEvents uses
    
                        dailyEvents.loadDate(all_dates[date_str],function(out){
                            $('.events',events_display).html(out);
                            $('> h3',events_display).html('Designer Events for '+target.date.format('MMMM Do'));
                        },true);
                    }
                    //END events
                    //BEGIN timepicker
                    
                    times=$('<div class="times"></div>');
                    //times+="<label for='apt-time'>Appointment Times for "+target.date.format('dddd MMMM Do, YYYY')+"</label>" + "<select name='apt' id='apt-time'></select>";
                   
                    var date;

                    appointment_calendar.find('.form-holder .details').hide();
                    appointment_calendar.find('.form-holder .bottom p').hide();
                    appointment_calendar.find('.form-holder .sat-apt').hide();
                    appointment_calendar.find('.form-holder .bottom button').addClass('inactive');

                    var detail=[];
                    if(typeof wp_vars["apt_details_list"] != 'undefined')
                        detail=wp_vars["apt_details_list"].slice(0);

                    if(target.events.length>0)
                    {
                        var evt=target.events[0];
                        if(evt['guests'])
                            detail.unshift('Maximum of '+evt['guests']+' guests');
                        if(evt['duration']) {
                            var dur = evt['duration'];
                            if(dur > 90) {
                                detail.unshift((dur/60)+'-hour appointment');
                            } else {
                                detail.unshift(dur+'-minute appointment');
                            }                         
                        }


                        if(booking_fee && typeof booking_fee['day'+target.date.isoWeekday()] != 'undefined')
                        {
                            var day = booking_fee['day'+target.date.isoWeekday()];
                            var start = true;//empty is ok
                            var end = true;
                            if(day.start)
                            {
                                start = moment(day.start+'T000000');
                                start = start.isValid() && target.date.isSameOrAfter(start);
                            }
                            if(day.end)
                            {
                                end = moment(day.end+'T235959');
                                end = end.isValid() && target.date.isBefore(end);
                            }
                            if(start && end)
                            {
                                var li = $('<li/>');
                                li.append(booking_fee_name+': $'+day.fee);
                                
                                if(day.message)
                                {
                                    var button = $('<button/>', {
                                        'type': 'button',
                                        'class': 'info-button',
                                        'data-title': booking_fee_name,
                                        'data-message': day.message,
                                    });
                                    button.html('<span class="screen-reader-text">detail</span></button>');
                                    li.append(button);
                                }

                                detail.push(li);
                            }
                        }

                        if(detail)
                        {
                            var details=$('<ul>');
                            for(var j in detail)
                            {
                                if(typeof detail[j] == 'object')
                                    details.append(detail[j]);
                                else
                                    details.append('<li>'+detail[j]+'</li>');
                            }
                            appointment_calendar.find('.form-holder .details ul').remove();
                            var d = appointment_calendar.find('.form-holder .details').append(details).show();
                            $('.info-button', d).click(function(){
                                if(!$(this).data('popup')) {
                                    var popup = $('<div class="info-popup">');
                                    var message = $(this).data('message');
                                    popup.html(message);
                                    if($(this).data('title'))
                                        popup.prepend('<h3>'+$(this).data('title')+'</h3>');
                                    popup.append('<button type="button" class="close"><span class="screen-reader-text">close</span></button>');
                                    popup.hide();
                                    $(this).data('popup', popup);
                                    var wrap = $('<div class="info-popup-wrap">');
                                    wrap.append(popup);
                                    $(this).after(wrap);
                                    $('.close', popup).click(function(){
                                        popup.fadeOut();
                                    });
                                }
                                $(this).data('popup').fadeToggle();
                            });
                        }
                    }

                    for(var i in target.events)
                    {                    
                        date=moment(target.events[i].date); 
                        
                        var btn=$('<button type="button">'+date.format('h:mma')+'</button>');
                        btn.data('event',target.events[i]);
                        btn.click(function(){
                            $(this).siblings('button').removeClass('active');
                            $(this).addClass('active');

                            appointment_calendar.find('.form-holder .errors').html("");
                            appointment_calendar.find('.form-holder .bottom').show();
                            appointment_calendar.find('.form-holder .bottom button').removeClass('inactive');
                            var evt=$(this).data('event');
                            
                                                
                            if(evt['reserve'])
                            {
                                appointment_calendar.find('.form-holder .reserve-time').html(evt['reserve']);
                                appointment_calendar.find('.form-holder .bottom p').show();
                            }
                            else
                            {
                                appointment_calendar.find('.form-holder .bottom p').hide();
                            }
                        });
                        if(qparams['apt'] && qparams['apt'].isSame(date)) 
                            btn.click();
                        times.append(btn);                        
                        //select.append('<option '+selected+' value="'+date.format('YYYY-MM-DD HH:mm:ss')+'">'+date.format('h:mma')+'</option>');
                    }
        

                    
                    //var desktop_timepicker=timepicker.clone();
                    //desktop_timepicker.addClass('desktop-form-holder');
                    if(appointment_calendar.find('.form-holder').length)
                    {
                        if(recaptcha_id===false)
                        {
                            grecaptcha.ready(function() {
                                recaptcha_id=grecaptcha.render('g-recaptcha-appointment-cal', {
                                  'sitekey': '6Lex9ScUAAAAAJMZmJ_BnKc6c1_6XA4owii48Bnz',
                                  'size': 'invisible',
                                  'callback': function(token){//on execute
                                    appointment_calendar.find('.form-holder .errors').html("");
                                    var evt=appointment_calendar.find('.form-holder .times .active').data('event');
                                    if(!evt)
                                    {
                                        appointment_calendar.find('.form-holder button[type=submit]').attr('disabled',false);
                                        return;
                                    }
                                    var args={
                                        'appointmentType':cal.element.data('appointment-type'),
                                        'appointmentDate':moment(evt.date).format('YYYY-MM-DD HH:mm:ss'),
                                        'token':token,
                                        'appt-cal':true,
                                        'duration':evt['duration'],
                                        'guests':evt['guests'],
                                    };
                                    if(appointment_calendar.data('en-appt-override'))
                                        args['en_appt_override']=1;
                                    if(test_mode)
                                        args['test_mode']=1;
                                    $.post('/',args,function(resp){
                                        appointment_calendar.find('.form-holder button[type=submit]').attr('disabled',false);
                                        if(typeof resp.ok == 'undefined')
                                        {
                                            appointment_calendar.find('.form-holder .errors').html('Server error (0)');
                                            grecaptcha.reset(recaptcha_id);
                                            return;
                                        }
                                        if(!resp.ok)
                                        {
                                            appointment_calendar.find('.form-holder .errors').html(resp.error);
                                            grecaptcha.reset(recaptcha_id);
                                            return;
                                        }
                                        if(apt_page_url.indexOf('?')===-1)
                                            window.location.href=apt_page_url+'?booking=1';
                                        else
                                            window.location.href=apt_page_url+'&booking=1';
                                    });
                                  }
                                });
                            });
                        }                                                    
                        appointment_calendar.find('.form-holder .times').replaceWith(times);
                        appointment_calendar.find('.form-holder .inner').slideDown();
                        //USE ISO

                        //if(show_events)
                            //appointment_calendar.find('.desktop-form-holder').replaceWith(desktop_timepicker);
                    }
                    //END timepicker
                },
                onMonthChange: function (month) {
                    this.element.find('form').slideUp(function(){
                        $(this).remove();
                    })
                    getCalendarEvents(month.format('YYYY-MM'));
                }
            },
            constraints: {
                startDate: calendar_start,
                endDate: moment().add(6, 'M')
            },
            startWithMonth: calendar_start,
            showAdjacentMonths:false
        });
        if(!hide_form)
        {
            var form='<div class="form-holder">';
                form+='<div class="inner" style="display:none;">';
                    form+='<div class="options"><h3>Available Times</h3><div class="times"></div></div>';
                    form+='<div class="details"><h3>Appointment Details</h3></div>';
                form+='</div>';
                form+='<div class="bottom">';
                    form+='<button type="submit" class="primary-button inactive">Reserve Date</button>';
                    form+='<p>You will have <strong><span class="reserve-time"></span> minutes</strong> to complete your profile and confirm your appointment once you reserve your date.</p>';
                form+='</div>';
                form+='<div class="errors"></div>';
                form+='<div id="g-recaptcha-appointment-cal"></div>';
                form+=extra;
            form+='</div>';
            form=$(form);
            $('.bottom p', form).hide();//hide reserve time
            cal.calendarContainer.after(form);
            
            $('button[type=submit]',form).click(function(){
                if($('.clndr .day.active',appointment_calendar).length < 1) {
                    appointment_calendar.find('.form-holder .errors').html('Please select a date to continue');
                    return;
                }
                if($('.form-holder .times .active',appointment_calendar).length < 1) {
                    appointment_calendar.find('.form-holder .errors').html('Please select a time to continue');
                    return;
                }

                $(this).attr('disabled',true);
                grecaptcha.execute(recaptcha_id);
            });           
        } 
        if(show_events)
        {
            var events_holder=$('<div class="events-display-holder"></div>');
            events_holder.append(events_display);
            $('.'+show_events).append(events_holder);
            //cal_holder.append(events_holder)
            //appointment_calendar.append(cal_holder);  
            appointment_calendar.addClass('with-events');
        }
        
        function getCalendarEvents(month)
        {
            cal.element.find('.loading').show();
            var args={getCalendar:month};
            var en_appt_override=appointment_calendar.data('en-appt-override');
            var appointment_type=cal.element.data('appointment-type');
            if(appointment_type)
                args['appointmentType']=appointment_type;
            if(en_appt_override)
                args['en_appt_override']=1;
            if(test_mode)
                args['test_mode']=1;
            $.get('/',args,function(resp){
                if(typeof resp.ok == 'undefined')
                    return;
                if(resp.ok) {
                    var withSlots = resp.data.filter(function(d){return d.slots > 0});
                    cal.setEvents(withSlots);
                }
                if(qparams['apt'])
                    $('.calendar-day-'+qparams['apt'].format('YYYY-MM-DD')).click();
                cal.element.find('.loading').hide();
            });
        }
        
        if(typeof qparams['apt'] != 'undefined')
        {
            var apt=moment(qparams['apt'].replace('+',' '));
            if(apt.isValid() && moment().add(4, 'M').month()>=apt.month() && moment().month()<=apt.month())
            {
                qparams['apt']=apt;
                cal.setMonth(apt.month());
                getCalendarEvents(apt.format('YYYY-MM'));
            }
            else
            {
                qparams['apt']=false;
                getCalendarEvents(moment().format('YYYY-MM'));
            }
        }
        else
        {
            qparams['apt']=false;
            getCalendarEvents(calendar_start.format('YYYY-MM'));
        }
    });

    $('.appointment-and-search .apt-popup > h3, .appointment-and-search  .search-popup > h3').click(function(){
        var popup=$(this).closest('.apt-popup, .search-popup');
        var others=$(this).closest('.appointment-and-search').not(popup);
        others.find('.holder').slideUp();
        others.removeClass('active');
        popup.find('.holder').slideDown();
        popup.addClass('active');
    });
    $('.appointment-and-search .apt-popup .close, .appointment-and-search  .search-popup .close').click(function(){
        var popup=$(this).closest('.apt-popup, .search-popup');
        popup.find('.holder').slideUp();
        popup.removeClass('active');
    });

    $('.price-range-dropdown').change(function(){
        var val=$(this).val();
        if(val=="")
        {
            $(this).siblings('input[name="min_price"]').val("");
            $(this).siblings('input[name="max_price"]').val("");
            return;
        }
        var range=val.split('|');
        $(this).siblings('input[name="min_price"]').val(range[0]);
        if(range.length>1)
            $(this).siblings('input[name="max_price"]').val(range[1]);
        else
            $(this).siblings('input[name="max_price"]').val("");
    });
    $('.date-picker input, input.datepicker, input.input-date').datepicker({
        autoHide:true,
        startDate:moment().subtract(3, 'years').toDate(),
        endDate:moment().add(30, 'years').toDate()
    }).change(function(e){
        if(typeof e.originalEvent != 'undefined'){
            if($(this).val())
                $(this).datepicker('setDate',moment($(this).val()).toDate());
            else
                $(this).datepicker('setDate',null);
        }
    });

    $('body.single-post .content a > img').each(function(){

        if($(this).attr('src').includes($(this).parent().attr('href').replace(/\.[0-9a-z]+$/i,"")))
        {
            $(this).parent().css('outline',0);
            $(this).parent().magnificPopup({'type':'image',removalDelay: 300, mainClass: 'mfp-fade'});
        }
    });

    $('a[data-ga-event]').click(function(e){
        var ga_click=$(this).data('ga-event');
        var parts=ga_click.split(',');
        if(parts.length<2)
            return;
        var vars=['eventCategory','eventAction','eventLabel'];
        var args={hitType: 'event'};
        for(var i in parts)
        {            
            var part=parts[i].replace(/^\s+|\s+$/g,'');
            part=part.replace(/^"+|"+$/g,'');
            part=part.replace(/^'+|'+$/g,'');
            args[vars[i]]=part;
        }
        if(typeof ga!= 'undefined')
        {
            ga.getAll()[0].send(args);
        }
    });

    moment.relativeTimeThreshold('ss', 0);
    $('.step-2-heading').each(function(){
        if(typeof wp_vars == 'undefined' || typeof wp_vars['apt_reserve_data'] == 'undefined')
            return;
        var expiration=moment(wp_vars['apt_reserve_data']['expiration']);
        if(!expiration)
            return;
        $(this).data('expiration',expiration);
        var self=$(this);
        var duration, time;
        var int=setInterval(function(){
            if(self.data('expiration').unix()-moment().unix()<0)
            {
                clearInterval(int);
                location.reload();
            }
            $('.timer', self).html('<span>Time remaining:</span> <span>'+self.data('expiration').fromNow(true)+'</span>').show();
        },1000);
    });

    $('.addonselect-select').change(function(){
        var input=$(this).siblings('.addonselect-value');
        var list=$(this).siblings('.addonselect-list');;
        var chosen=input.val().split('||');
        if(input.val()=="")
            chosen=[];
        if($(this).data('limit') && chosen.length>=$(this).data('limit'))
            return;
        var val=$(this).val();
        if(val && !chosen.includes(val))
            chosen.push(val);
        
        input.val(chosen.join('||'));
        var ul='<ul>';
        for(var i in chosen)
        {
            if(!chosen[i])
                continue;
            var name=$('[value="'+chosen[i]+'"]',this).text();
            ul+='<li data-value="'+chosen[i]+'"><span class="name">'+name+'</span><button type="button"><span class="screen-reader-text">Remove</span></button></li>';
        }
        ul+='</ul>';
        ul=$(ul);
        $('button', ul).click(function(){
            var input=$(this).closest('.addonselect-list').siblings('.addonselect-value');
            var chosen=input.val().split('||');
            if(input.val()=="")
                chosen=[];
            var index = chosen.indexOf($(this).closest('li').data('value'));
            if (index > -1)
                chosen.splice(index, 1);
            input.val(chosen.join('||'));
            $(this).closest('.addonselect-list').siblings('.addonselect-select').val("").change();//update
        });
        setTimeout(function(){
            list.html(ul);
        },50);
        
        //list.append(ul);
    }).change();

    
    function appt_field_change()
    {
        var name=$(this).attr('name');
        var value=$(this).val();
        if($(this).hasClass('addonselect-select'))
        {
            name=$(this).siblings('.addonselect-value').attr('name');
            value=$(this).siblings('.addonselect-value').val();
        }
        if($(this).closest('.form-row').hasClass('type-checkbox'))
        {
            value=0;
            if($(this).is(':checked'))
                value=1;
        }
        if($(this).closest('.form-row').hasClass('type-multicheckbox'))
        {
            value=[];
            var self=$(this);
            if($(this).is(':checked'))
                value.push($(this).attr('value'));
            $(this).siblings('input').each(function(){
                if($(this).not(self).is(':checked'))
                    value.push($(this).attr('value'));
            });
            name=name.replace('[]','');
        }
        var reject=['ccnumber','ccexpdate','cccvc','password','action','_wpnonce','_wp_http_referer'];
        if(reject.includes(name))
            return;
        if(typeof name == 'undefined')
            return;

        var fields = localStorage.getItem('appt-fields');
        try{
            if(!fields)
                fields={};
            else
                fields=JSON.parse(fields);
        }catch(e){
            fields={};
        }
        fields[name]=value;
        localStorage.setItem('appt-fields',JSON.stringify(fields));
    }
    
    if($('.page-template-page-appointments2').length>0)
    {
        var appt_page=$('.page-template-page-appointments2');
        var fields = localStorage.getItem('appt-fields');
        try{
            if(!fields)
                fields={};
            else
                fields=JSON.parse(fields);
        }catch(e){
            fields={};
        }
        $('.page-template-page-appointments2 .form-row select, .page-template-page-appointments2 .form-row input').each(function(){
            var name=$(this).attr('name');
            if(typeof name == 'undefined')
                return;

            if($(this).closest('.form-row').hasClass('type-multicheckbox'))
                name=name.replace('[]','');

            if(typeof fields[name] != 'undefined')
            {
                if($(this).attr('type')=="radio")
                {
                    if($(this).attr('value')==fields[name])
                        $(this).attr('checked',true);
                }
                else if($(this).attr('type')=="checkbox")
                {
                    if(typeof fields[name].includes != 'undefined' && fields[name].includes($(this).attr('value')))
                        $(this).attr('checked',true);
                    else if(typeof fields[name].includes == 'undefined')
                        $(this).attr('checked',fields[name]!=0);
                }
                else
                {
                    $(this).val(fields[name]);
                }
            }

            if($(this).closest('.form-row').hasClass('type-addonselect'))
                $(this).closest('.form-row').find('.addonselect-select').change();
        });
    }
    
    var changeAble=$('.page-template-page-appointments2 .form-row select, .page-template-page-appointments2 .form-row input[type=checkbox], .page-template-page-appointments2 .form-row input[type=radio], .page-template-page-appointments2 .form-row.type-date input, .page-template-page-appointments2 .form-row.type-location input[type=hidden]');
    changeAble.change(appt_field_change);
    $('.page-template-page-appointments2 .form-row input').on('keyup',appt_field_change);

    $('.archive-hero-sections .section button').click(function(){
        var siblings = $(this).closest('.section').siblings('.section');
        $('.section-content', siblings).slideUp();
        $('button', siblings).removeClass('open');
        $(this).siblings('.section-content').slideToggle();
        $(this).toggleClass('open');

        var h2 = $('.archive-hero-content h2');
        if(h2.css('cursor') != "pointer")
            return;
        h2.removeClass('open');
        h2.siblings('.top-copy').slideUp();
    });

    $('.archive-hero-content h2').click(function(){
        if($(this).css('cursor') != "pointer")
            return;
        $(this).toggleClass('open');
        $(this).siblings('.top-copy').slideToggle();

        $('.archive-hero-sections .section .section-content').slideUp();
        $('.archive-hero-sections .section button').removeClass('open');
    }); 

    $('.mobile-jump').click(function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 100
        }, 500);
    });

    //Contact form 7 reCaptcha
    function cf7Captcha(){
        if(typeof $(this).data('recaptcha') == 'undefined' || $(this).data('recaptcha') === false){
            var self = $(this);
            $(this).data('recaptcha', grecaptcha.render($('.wpcf7-submit', this).get(0), {//attach recaptcha check to submit button, callback fires when user approved
                'sitekey': '6Lex9ScUAAAAAJMZmJ_BnKc6c1_6XA4owii48Bnz',
                'size': 'invisible',
                'callback': function(token){//on execute
                    self.submit();
                }
            }));
        }
    }
    $('form.wpcf7-form').on('focusin', cf7Captcha); // initialize recaptcha when focused in form

    //Registration Form
    registerToken=false;
    function registerCaptcha(){
        if(registerToken===false){
            registerToken = grecaptcha.render('registerprofile', {//attach recaptcha check to submit button, callback fires when user approved
                'sitekey': '6Lex9ScUAAAAAJMZmJ_BnKc6c1_6XA4owii48Bnz',
                'size': 'invisible',
                'callback': function(token){//on execute
                    jQuery('#registerprofile').parents('form').submit()
                }
            })
        }
    }
    jQuery('#registerprofile').parents('form').on('focusin',registerCaptcha) // initialize recaptcha when focused in form

    $('.hide-pre-js').removeClass('hide-pre-js');
    
});
function backToSearch()
{
    history.back();
}
function aptFormSubmit(token)
{
    document.getElementById('aptForm').submit();
}
function fb_event(event)
{
    if(typeof fbq != 'undefined')
    {
        fbq('track', event);
    }
    return true;
}